import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class PrebookResource {
  private baseUri = '/prl/prebooks';

  constructor(private ApiService: ApiService) {}

  // POST
  confirmPrebook(params: { prebookId: string }): Observable<Docorga.interfaces.prebook.IPrebookConfirmResult> {
    return this.ApiService.post(`${this.baseUri}/${params.prebookId}/confirm`);
  }

  // PUT
  updatePrebookPatient(params: {
    prebookId: string;
    patientId: Docorga.interfaces.naturalTypes.NPatientObjectId | null;
    address?: Docorga.interfaces.common.ICommonAddress;
  }): Observable<Docorga.interfaces.prebook.IPrebookJson> {
    return this.ApiService.put(`${this.baseUri}/${params.prebookId}/patient`, params);
  }
}
